// extracted by mini-css-extract-plugin
export var alertIcon = "_oi-0";